export class ServicesTypePostModel {
    serviceId: number;
    serviceContractId: number;
    modality: string;
    tradeName: string;
    institutionId: string;
    terminalManufacturerId: number;
    deviceOnAgency: boolean;
    isEnabled: boolean;
    advantages: string;
    details: string;
    isPiloto: boolean;
    disclaimer: string;
}
